import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24.514 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M1 14v9h9v-9H1m0-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1ZM24.014 17.176H14.008a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h10.006a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5ZM20.678 21.179h-6.67a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h6.67a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5ZM1 1v9h9V1H1m0-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1ZM24.014 3.835H14.008a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h10.006a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5ZM20.678 7.838h-6.67a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h6.67a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5Z" })
    ], -1)
  ])))
}
export default { render: render }